import React from "react"
import TagsInput from "react-tagsinput"
import AutosizeInput from "react-input-autosize"
import { compose, withHandlers } from "recompact"
import CloseIcon from "src/icons/close.svg"
import indexOf from "lodash/indexOf"
import styles from "./styles.css"

const enhance = compose(
  withHandlers({
    onRemove: ({ tag, tagsArray, onRemove }) => () => {
      const index = indexOf(tagsArray, tag)
      onRemove(index)
    },
    onChange: ({ onChange }) => value => {
      onChange(value)
    },
  }),
)
const CustomRenderTag = enhance(
  ({
    tag,
    key,
    tagsArray,
    disabled,
    onRemove,
    classNameRemove,
    getTagDisplayValue,
    ...other
  }) => (
    <span key={key} {...other}>
      <span>{getTagDisplayValue(tag)}</span>
      {!disabled && (
        <span onClick={onRemove} className={classNameRemove}>
          <CloseIcon size="small" />
        </span>
      )}
    </span>
  ),
)

const CustomRenderInput = enhance(({ value, onChange, ...other }) => (
  <span>
    <AutosizeInput
      type="text"
      className={styles.input}
      maxlength={126}
      onChange={onChange}
      value={value}
      {...other}
    />
  </span>
))
export default ({
  input: { value, onChange },
  tagsArray,
  meta: { valid, error },
  ...restProps
}) => {
  const renderTagWrapper = props => (
    <CustomRenderTag {...props} tagsArray={tagsArray} />
  )
  const renderInputWrapper = props => (
    <CustomRenderInput {...props} tagsArray={tagsArray} />
  )
  return (
    <div>
      <TagsInput
        {...restProps}
        value={value || []}
        invalid={!valid}
        tagsArray={tagsArray}
        onChange={onChange}
        focusedClassName={styles.focused}
        onlyUnique
        renderTag={renderTagWrapper}
        renderInput={renderInputWrapper}
        tagProps={{
          className: styles.tags,
          classNameRemove: styles.remove,
        }}
        inputProps={{
          className: styles.input,
          maxlength: 126,
          placeholder: `Введите наименование тега`,
        }}
        className={styles.TagsInput}
      />
      <div className={styles[`input-error`]}>{error}</div>
    </div>
  )
}
